export function BadRequestError(error) {
  this.type = error.type;
  this.title = error.title;
  this.detail = error.detail;
  this.errors = error.errors;
  this.toString = () => {
    return this.detail;
  };
}
